import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RoundButton from '../../../../components/_atomic/RoundButton/RoundButton';
import { API_ROUTES } from '../../../../utils/constants';
import { getHashURLParameters, getHash } from '../../../../utils/helpers';

const googleIcon = require('../../../../assets/images/AuthFlow/google.png');

class GoogleLoginButton extends Component {
  static propTypes = {
    login: PropTypes.func.isRequired,
  }

  componentDidMount() {
    const searchParams = getHash();
    if (searchParams && searchParams.indexOf('google') > -1) {
      const searchParamsObj = getHashURLParameters(searchParams);
      this
        .props
        .login({ route: API_ROUTES.GOOGLE_LOGIN, token: searchParamsObj.access_token });
    }
  }

  oauthSignIn = () => {
    // Google's OAuth 2.0 endpoint for requesting an access token
    const oauth2Endpoint = 'https://accounts.google.com/o/oauth2/v2/auth';

    // Create <form> element to submit parameters to OAuth 2.0 endpoint.
    const form = document.createElement('form');
    form.setAttribute('method', 'GET'); // Send as a GET request.
    form.setAttribute('action', oauth2Endpoint);

    // Parameters to pass to OAuth 2.0 endpoint.
    const documentLocation = document.location;
    const params = {
      client_id: '706206209030-qc2g8ifl476nldhnuale8c98h89tgms2.apps.googleusercontent.com',
      redirect_uri: `${documentLocation.origin}${documentLocation.pathname}`,
      response_type: 'token',
      scope: 'https://www.googleapis.com/auth/drive.metadata.readonly',
      include_granted_scopes: 'true',
      state: 'pass-through value',
    };

    // Add form parameters as hidden input values.
    Object
      .keys(params)
      .forEach((p) => {
        const input = document.createElement('input');
        input.setAttribute('type', 'hidden');
        input.setAttribute('name', p);
        input.setAttribute('value', params[p]);
        form.appendChild(input);
      });

    // Add form to page and submit it to open the OAuth 2.0 endpoint.
    document.body.appendChild(form);
    form.submit();
  }

  render() {
    return (
      <RoundButton onClick={this.oauthSignIn} radius="32px"><img src={googleIcon} alt="Google logo" /></RoundButton>
    );
  }
}

export default GoogleLoginButton;



// WEBPACK FOOTER //
// ./src/containers/SocialLoginWrapper/components/GoogleLoginButton/GoogleLoginButton.js